import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const deleteMembros = async (token: string, cpf: string) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  await axios.delete(`${API_URL}/membros/${cpf}`, config);
};
export default deleteMembros;
